module.exports = "https://static.wmbcdn.com/uniweb/images/fba14a70ffc01e65dbe02311a76660ff.svg";